import {IDischargeCurveController} from './curve.controller';
import {List} from 'immutable';
import {IDischargeModelItem} from './model-list/model-list.controller';

const dischargeModelListCurveFactory:ng.IDirectiveFactory = () => {
  return {
    restrict: 'A',
    controller: DischargeModelListCurveController
  }
};
export default dischargeModelListCurveFactory;

export interface IDischargeModelListCurveController {
  addDischargeCurveController(dischargeCurveController:IDischargeCurveController):void;
  onDischargeModelItemsChange(dischargeModelItems:List<IDischargeModelItem>):void;
}

class DischargeModelListCurveController implements IDischargeModelListCurveController {
  private dischargeCurveController:IDischargeCurveController;
  private visibleDischargeModelItems:List<IDischargeModelItem>;

  constructor() {
    this.visibleDischargeModelItems = List<IDischargeModelItem>();
  }

  addDischargeCurveController(dischargeCurveController:IDischargeCurveController):void {
    this.dischargeCurveController = dischargeCurveController;
  }

  onDischargeModelItemsChange(dischargeModelItems:List<IDischargeModelItem>):void {
    this.visibleDischargeModelItems = dischargeModelItems
        .filter(dischargeModelItem => dischargeModelItem.enabled).toList();
    if (this.dischargeCurveController) {
      this.dischargeCurveController
          .onDischargeModelItemsChange(this.visibleDischargeModelItems);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/model-list-curve.directive.ts
 **/